@if (value === "-" || value === "") {
  <span>-</span>
} @else {
  <img [src]="value" [alt]="label" (error)="hiddenWhenUnresolved = true" [hidden]="hiddenWhenUnresolved" />
  <span [hidden]="!hiddenWhenUnresolved">-</span>
}
